export const user_info = "/web/v1/novel/user_detail";
